import React, { useEffect, useState } from "react";
import {
  HeroCircleContainer,
  HeroCircleWrapper,
  TitleContainer,
  TextContainer,
  HeroBg,
} from "./index.styled";
import useWindowDimensions from "../../utils/windowDimensions/WindowDimensions";
import { CustomButton } from "../../components/buttons/index.styled";
import { env } from "../../.env";
const HeroCicle = () => {
  /**
   * @desc link handler. after click user redirect to https://test-avanegar.partdp.ir/
   * @function
   */
  const linkHandler = () => {
    window.location.href = env.REACT_APP_PANEL_REDIRECT;
  };

  const [typing, setTyping] = useState(" ");

  useEffect(() => {
    const text = "تبدیل دقیق آوای فارسی به نوشتار...";

    let index = 0;

    let typing = true;

    let editedText = "";

    setInterval(() => {
      if (text[index] && typing) {
        editedText = editedText + text[index];
        index++;
      } else {
        setTimeout(() => {
          typing = false;
          editedText = editedText.slice(0, -1);
          index = 0;
          if (!editedText) {
            typing = true;
          }
        }, 3000);
      }
      setTyping(editedText);
    }, 120);
  }, []);

  // <circles
  const [circles, setCircles] = useState([]);

  useEffect(() => {
    let arr = [];
    for (let i = 1; i <= 3; i++) {
      const circle = <div className={`circle${i}`}></div>;
      arr.push(circle);
    }
    setCircles(arr);
  }, []);
  // circles>
  const dim = useWindowDimensions();
  return (
    // <HeroBg>
    <HeroCircleContainer className="circles">
      {circles.slice(0, 3).map((item) => item)}
      <HeroCircleWrapper>
        <TitleContainer>
          <h1>{typing.length >= 2 && typing}</h1>
        </TitleContainer>
        <TextContainer
          width="347px"
          width400="300px"
          height="96px"
          width600="232px"
        >
          <p color="#FFFFFF">
            آوانگار با استفاده از فناوری هوش مصنوعی سرویس تبدیل صوت به متن فارسی
            را توسعه داده که قابل ادغام با نرم‌افزارها و اپلیکیشن‌هاست.
          </p>
        </TextContainer>
        <div className="button-container">
          <CustomButton
            width="160px"
            height="48px"
            radius="2px"
            color="#12A46F"
            background="#FFFFFF"
            borderColor="#FFFFFF"
            backgroundHover="#12A46F"
            borderColorHover="#FFFFFF"
            colorHover="#FFFFFF"
            fontWeight="700"
            width740="160px"
            width680="160px"
            fontSize680="16px"
            onClick={linkHandler}
          >
            {dim.width < 481 ? "ورود به حساب" : "رایگان امتحان کنید"}
          </CustomButton>
        </div>
      </HeroCircleWrapper>
    </HeroCircleContainer>
    // </HeroBg>
  );
};

export default HeroCicle;
